var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-0 ma-0",attrs:{"justify":"center"}},[(
          _vm.$vuetify.breakpoint.mdAndUp &&
            !['Profile', 'Login', 'Register', 'NotFound'].includes(
              _vm.$route.name
            )
        )?[_c('v-col',{staticClass:"pa-0 ma-0 profile-left elevation-4",attrs:{"cols":"4"}},[_c('profile')],1),_c('v-col',{staticClass:"pa-0 ma-0",attrs:{"cols":"4"}})]:_vm._e(),_c('v-col',{staticClass:"pa-0 ma-0",attrs:{"cols":"12","md":"7","lg":"6"}},[_c('v-main',[_c('router-view')],1)],1)],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }